import React, { ReactElement } from 'react'

import Skeleton from '@material-ui/lab/Skeleton'

/**
 * Simple content loader that looks like a form inside tabs and the tabs menu on the left side.
 */
const TabsContentLoader: React.FC = (): ReactElement => (
    <div className='tabs-content-loader'>
        <div className='tabs-menu-loaders'>
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
            <Skeleton variant='text' width={140} height={50} />
        </div>
        <div className='tabs-content-loaders'>
            <div className='section'>
                <Skeleton variant='text' width={200} height={50} />
                <Skeleton variant='text' width={700} height={15} />
                <Skeleton variant='text' width={700} height={15} />
                <Skeleton variant='text' width={700} height={15} />
                <Skeleton variant='text' width={400} height={20} />
                <Skeleton variant='text' width={400} height={20} />
                <Skeleton variant='text' width={150} height={20} />
                <Skeleton variant='text' width={400} height={20} />
                <Skeleton variant='text' width={400} height={20} />
            </div>
            <div className='section'>
                <Skeleton variant='text' width={200} height={50} />
                <Skeleton variant='text' width={700} height={15} />
                <Skeleton variant='text' width={700} height={15} />
                <Skeleton variant='text' width={700} height={15} />
                <Skeleton variant='text' width={400} height={20} />
                <Skeleton variant='text' width={400} height={20} />
                <Skeleton variant='text' width={150} height={20} />
                <Skeleton variant='text' width={400} height={20} />
                <Skeleton variant='text' width={400} height={20} />
            </div>
        </div>
    </div>
)

export default TabsContentLoader
